export const QR_PUBLIC_BASE_URL =
  process.env.REACT_APP_QR_PUBLIC_BASE_URL || "https://tq2.ai";

const RESERVED_PATHS = new Set([
  "about-us",
  "admin",
  "contact-us",
  "content",
  "dashboard",
  "how-it-works",
  "landing",
  "login",
  "privacy-policy",
  "profile",
  "services",
  "signup",
  "terms-of-service",
  "testimonials",
]);

export const normalizeQrTag = (tag = "") =>
  String(tag).trim().replace(/^\/+|\/+$/g, "").toLowerCase();

export const isShortQrPath = (pathname = "") => {
  const segments = String(pathname).split("/").filter(Boolean);
  if (segments.length !== 1) {
    return false;
  }

  const segment = segments[0];
  if (RESERVED_PATHS.has(segment.toLowerCase())) {
    return false;
  }

  return /^[a-z0-9][a-z0-9_-]*$/i.test(segment);
};

export const getQrTagFromLocation = (location) => {
  const searchParams = new URLSearchParams(location?.search || "");
  const queryTag = searchParams.get("un");
  if (queryTag) {
    return normalizeQrTag(queryTag);
  }

  if (!isShortQrPath(location?.pathname || "")) {
    return "";
  }

  const [pathTag] = String(location.pathname).split("/").filter(Boolean);
  try {
    return normalizeQrTag(decodeURIComponent(pathTag));
  } catch (error) {
    return normalizeQrTag(pathTag);
  }
};

export const extractQrTagFromText = (value = "") => {
  try {
    const parsedUrl = new URL(String(value));
    const queryTag = parsedUrl.searchParams.get("un");
    if (queryTag) {
      return normalizeQrTag(queryTag);
    }

    const [pathTag] = parsedUrl.pathname.split("/").filter(Boolean);
    return pathTag ? normalizeQrTag(decodeURIComponent(pathTag)) : "";
  } catch (error) {
    return "";
  }
};

export const buildTattooQrUrl = (tag, baseUrl = QR_PUBLIC_BASE_URL) => {
  const normalizedTag = normalizeQrTag(tag);
  if (!normalizedTag) {
    return "";
  }

  const cleanBaseUrl = String(baseUrl || QR_PUBLIC_BASE_URL).replace(/\/+$/g, "");
  const encodedTag = encodeURIComponent(normalizedTag)
    .replace(/_/g, "%5F")
    .toUpperCase();
  return `${cleanBaseUrl}/${encodedTag}`.toUpperCase();
};
